exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-daterange-picker{\n  display: inline-flex;\n}\n.daterangepicker-custom{\n  padding-top: 4px;\n  width: 440px;\n  text-align: center;\n}\n@media (max-width: 900px){\n.daterangepicker-custom{\n  padding-top: 4px;\n  width: 800px;\n  text-align: center;\n}\n}\n@media (max-width: 450px){\n.daterangepicker-custom{\n  padding-top: 4px;\n  width: 300px;\n  text-align: center;\n}\n}\n\n", ""]);

// exports
